

/**
 * Gets the reminder of the processed IBAN
 * @param {string} iban - processed IBAN
 * @returns {string} reminder
 */
function iso7064Mod97(iban) {
    let remainder = iban;
    let block;

    while (remainder.length > 2) {
        block = remainder.slice(0, 9);
        remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length);
    }

    return parseInt(remainder, 10) % 97;
}

/**
 * Processes IBAN
 * @param {string} iban - IBAN
 * @returns {string} processed IBAN
 */
function iso13616Prepare(iban) {
    const A = 'A'.charCodeAt(0);
    const Z = 'Z'.charCodeAt(0);

    let result = iban.toUpperCase();
    result = result.substr(4) + result.substr(0, 4);

    return result.split('').map((n) => {
        const code = n.charCodeAt(0);
        if (code >= A && code <= Z) {
            // A = 10, B = 11, ... Z = 35
            return (code - A) + 10;
        }
        return n;
    }).join('');
}

/**
 * Validates IBAN
 * @param {string} iban - iban
 * @returns {boolean} if IBAN is valid
 */
function isValid(iban) {
    return iso7064Mod97(iso13616Prepare(iban)) === 1;
}
module.exports = exports = {
    isValid,
};
